import React from 'react';
import { PatientECGPlotCell, AvatarCell } from 'components';
import { PatientTableItem } from 'types/types';
import { GridCellParams, GridColDef } from '@mui/x-data-grid';
import dayjs from 'dayjs';

export const COLUMNS: GridColDef[] = [
  {
    field: 'avatar',
    headerName: 'Avatar',
    width: 120,
    renderCell: (params: GridCellParams<PatientTableItem>) => <AvatarCell {...params.row} size={80} />,
    sortable: false,
  },
  {
    field: 'fullName',
    headerName: 'Full Name',
    minWidth: 150,
    sortable: false,
  },
  {
    field: 'dateOfBirth',
    headerName: 'Date of Birth',
    minWidth: 50,
    sortable: false,
    renderCell: (params: GridCellParams<PatientTableItem>) => dayjs(params.row.dateOfBirth).format('MM/DD/YYYY'),
  },
  {
    field: 'gender',
    headerName: 'Gender',
    minWidth: 50,
    sortable: false,
  },
  {
    field: 'waveform',
    headerName: 'Waveform',
    flex: 1,
    minWidth: 250,
    sortable: false,
    renderCell: (params: GridCellParams<PatientTableItem>) => <PatientECGPlotCell {...params.row} />,
  },
];
